<script setup lang="ts">
import Button from 'primevue/button';

type ButtonSeverity = 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'contrast';
type ButtonSize = 'small' | 'normal' | 'large';
type IconPos = 'left' | 'right' | 'top' | 'bottom';

interface Props {
  icon?: string;
  label?: string;
  severity?: ButtonSeverity;
  rounded?: boolean;
  outlined?: boolean;
  text?: boolean;
  size?: ButtonSize;
  disabled?: boolean;
  iconPos?: IconPos;
}

const props = withDefaults(defineProps<Props>(), {
  severity: 'primary',
  size: 'normal',
  disabled: false,
  iconPos: 'left',
});

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void;
}>();

</script>

<template>
  <Button
    :label="props.label"
    :severity="props.severity"
    :rounded="props.rounded"
    :outlined="props.outlined"
    :text="props.text"
    :size="props.size"
    :iconPos="props.iconPos"
    :disabled="props.disabled"
    icon-class="material-icons"
    @click="event => emit('click', event)"
  >
    <template #icon>
      <slot name="icon">
        <span v-if="props.icon" class="material-icons">{{ props.icon }}</span>
      </slot>
    </template>
    <slot></slot>
  </Button>
</template>
